import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useRef, useState } from "react";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

import { useEffect } from "react";
import {
  GetAllCitiesByProvinceId,
  GetAllProvinces,
} from "../../services/ProvinceService";
import {
  GetAllCategories,
  GetCategoryById,
} from "../../services/CategoryService";
import { CreateNotice } from "../../services/NoticeService";
import imageCompression from "browser-image-compression";
import { CreateCompany } from "../../services/CompanyService";
import { useNavigate } from "react-router-dom";

const NewNotice = () => {
  const navigate = useNavigate();
  useEffect(() => {
    getProvinces();
    getCategories();
  }, []);

  const [categoryLevels, SetCategoryLevels] = useState([]);
  const [getCityAndCount, SetCityAndCount] = useState([]);
  const [categories, SetCategories] = useState([]);
  const [provinces, SetProvinces] = useState([]);
  const [cities, SetCities] = useState([]);

  const getCategories = async () => {
    const rawData = await GetAllCategories();
    addDD({ selectedItem: "", cat: rawData.data.data });
  };

  const getProvinces = async () => {
    const rawData = await GetAllProvinces();

    SetProvinces(rawData.data.data);
  };

  const [getData, SetِData] = useState({
    title: "",
    description: "",
    noticeType: 0,
    categoryId: "",
    image: null,
    locationVolumes: [],
  });
  const [selectedCityAndProvince, SetSelectedCityAndProvince] = useState({
    provinceId: "",
    cityId: "",
    count: 0,
    cityCaption: "",
  });
  const updateDD = (index: any, value: any) => {
    console.log(categories);
    console.log("i=" + index + " v =" + value);
    let newCategories = [...categories];
    newCategories[index - 1]["selectedItem"] = value as never;
    SetCategories(newCategories);
    console.log(categories);
  };
  const FetchNextCategory = async (e: any) => {
    console.log(e);
    SetِData({
      ...getData,
      ["categoryId"]: e.target.value,
    });
    updateDD(e.target.id, e.target.value);
    // console.log(e.target.id);
    let rawData = await GetCategoryById(e.target.value);
    addDD({ id: e.target.id, selectedItem: "", cat: rawData.data.data });
  };

  const addDD = (input: any) => {
    if (input.id) {
      //console.log("RM" + input.id);
      SetCategories((current) =>
        current.filter((o) => (o as any).id < input.id + 1)
      );
    }

    console.log(input);
    SetCategories((current) => [
      ...current,
      {
        id: current.length + 1,
        catdata: input.cat,
        selectedItem: input.selectedItem,
      } as never,
    ]);
    //console.log(categories);
  };

  const addCityAndCount = (id: any) => {
    id.persist();
    id.preventDefault();
    //console.log(getCityAndCount);

    SetCityAndCount((current) => [
      ...current,
      {
        id: current.length + 1,
        cityId: selectedCityAndProvince.cityId,
        cityCaption: selectedCityAndProvince.cityCaption,
        provinceId: selectedCityAndProvince.provinceId,
        count: selectedCityAndProvince.count,
      } as never,
    ]);
  };
  const removeCityAndCount = (id: any) => {
    SetCityAndCount((current) => current.filter((o) => (o as any).id !== id));
  };

  const [totalSize, setTotalSize] = useState(0);
  const toast = useRef(null);
  const fileUploadRef = useRef(null);

  const SetSelectedProvinceDataInfo = (e: any) => {
    if (e.target.name === "provinceId") {
      LoadCities(e.target.value.id);
    }

    SetSelectedCityAndProvince({
      ...selectedCityAndProvince,
      [e.target.name]: e.target.value,
    });
    console.log(selectedCityAndProvince);
  };

  const LoadCities = async (provinceId: any) => {
    let data = await GetAllCitiesByProvinceId(provinceId);
    SetCities(data.data.data);
  };

  const SetDataInfo = (event: any) => {
    SetِData({
      ...getData,
      [event.target.name]: event.target.value,
    });
  };

  const headerTemplate = (options: any) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    const value = totalSize / 10000;
    const formatedValue =
      fileUploadRef && fileUploadRef.current
        ? (fileUploadRef.current as any).formatSize(totalSize)
        : "0 B";

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}
        {/* {uploadButton} */}
        {cancelButton}
        {/* <ProgressBar
					value={value}
					displayValueTemplate={() => `${formatedValue} / 1 MB`}
					style={{
						width: "300px",
						height: "20px",
						marginLeft: "auto",
					}}></ProgressBar> */}
      </div>
    );
  };

  const itemTemplate = (file: any, props: any) => {
    return (
      <div className="flex align-items-center flex-wrap">
        <div className="flex align-items-center" style={{ width: "40%" }}>
          <img
            alt={file.name}
            role="presentation"
            src={file.objectURL}
            width={100}
          />
          <span className="flex flex-column text-left ml-3">
            {file.name}
            <small>{new Date().toLocaleDateString()}</small>
          </span>
        </div>
        <Tag
          value={props.formatSize}
          severity="warning"
          className="px-3 py-2"
        />
        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </div>
    );
  };
  const onTemplateSelect = (e: any) => {
    let _totalSize = totalSize;
    e.files.forEach((file: any) => {
      _totalSize += file.size;
    });
    setTotalSize(_totalSize);
  };
  const onTemplateUpload = (e: any) => {
    console.log(e);

    // SetِData({
    // 	...getData,
    // 	["files"]: e.files[0],
    // });
    // console.log(getData);

    // } else {
    // let _totalSize = 0;
    // e.files.forEach((file) => {
    // 	_totalSize += file.size || 0;
    // });
    // setTotalSize(_totalSize);
    // toast.current.show({
    // 	severity: "info",
    // 	summary: "Success",
    // 	detail: "File Uploaded",
    // });
  };

  const onTemplateRemove = (file: any, callback: any) => {
    setTotalSize(totalSize - file.size);
    callback();
  };

  const onTemplateClear = () => {
    setTotalSize(0);
  };

  const onBasicUpload = () => {
    (toast.current as any).show({
      severity: "info",
      summary: "Success",
      detail: "File Uploaded with Basic Mode",
    });
  };

  const onBasicUploadAuto = () => {
    (toast.current as any).show({
      severity: "info",
      summary: "Success",
      detail: "File Uploaded with Auto Mode",
    });
  };
  const emptyTemplate = () => {
    return (
      <div className="flex align-items-center flex-column">
        {/* <i
					className="pi pi-image mt-3 p-5"
					style={{
						fontSize: "5em",
						borderRadius: "50%",
						backgroundColor: "var(--surface-b)",
						color: "var(--surface-d)",
					}}></i> */}
        <span
          style={{
            display: "absolute",
            fontSize: "1.2em",
            color: "var(--text-color-secondary)",
          }}
          className="my-5"
        >
          لطفا لوگوی مربوط به فروشگاه را بارگذاری کنید
        </span>
      </div>
    );
  };
  const chooseOptions = {
    icon: "pi pi-fw pi-images",
    iconOnly: true,
    className: "custom-choose-btn p-button-rounded p-button-outlined",
  };
  const uploadOptions = {
    icon: "pi pi-fw pi-cloud-upload",
    iconOnly: true,
    className:
      "custom-upload-btn p-button-success p-button-rounded p-button-outlined",
  };
  const cancelOptions = {
    icon: "pi pi-fw pi-times",
    iconOnly: true,
    className:
      "custom-cancel-btn p-button-danger p-button-rounded p-button-outlined",
  };

  {
    /*DropDown Start */
  }

  const selectedCountryTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="country-item country-item-value">
          {/* <img
						alt={option.name}
						src="images/flag/flag_placeholder.png"
						onError={(e) =>
							(e.currentTarget.src =
								"https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png")
						}
						className={`flag flag-${option.code.toLowerCase()}`}
					/> */}
          <div>{option.localizedName}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const countryOptionTemplate = (option: any) => {
    return (
      <>
        <div className="country-item">
          {/* <img
					alt={option.name}
					src="images/flag/flag_placeholder.png"
					onError={(e) =>
						(e.target.src =
							"https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png")
					}
					className={`flag flag-${option.code.toLowerCase()}`}
				/> */}
          <div>{option.localizedName}</div>
        </div>
      </>
    );
  };
  const countryOptionTemplate2 = (option: any) => {
    return (
      <div className="country-item">
        {/* <img
					alt={option.name}
					src="images/flag/flag_placeholder.png"
					onError={(e) =>
						(e.target.src =
							"https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png")
					}
					className={`flag flag-${option.code.toLowerCase()}`}
				/> */}
        <div>222</div>
      </div>
    );
  };
  {
    /* Drop Down End */
  }

  const SetCategory = async () => {
    console.log(categories[categories.length - 2]["selectedItem"]);
    SetِData((getData) => {
      return {
        ...getData,
        ["categoryId"]: categories[categories.length - 2]["selectedItem"],
      };
    });
  };
  const submit = async (e: any) => {
    e.preventDefault();
    SetِData((getData) => {
      return {
        ...getData,
        ["locationVolumes"]: getCityAndCount,
      };
    });
    await CreateCompany(getData).then((p) => navigate("/companies"));
    //console.log(getData);
    // (p) => navigate("/");
  };

  function dynamicSort(property: any) {
    return function (a: any, b: any) {
      return a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    };
  }
  const customBase64Uploader = async (event: any) => {
    // convert file to base64 encoded
    const file = event.files[0];
    console.log("originalFile instanceof Blob", file instanceof Blob); // true
    console.log(`originalFile size ${file.size / 1024 / 1024} MB`);

    const options = {
      maxSizeMB: Number.POSITIVE_INFINITY,
      maxWidthOrHeight: 2048,
      useWebWorker: true,
      fileType: "image/jpeg",
      initialQuality: 1.0,
    };
    const compressedFile = await imageCompression(file, options);
    console.log(
      "compressedFile instanceof Blob",
      compressedFile instanceof Blob
    ); // true
    console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

    const reader = new FileReader();
    //let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url

    reader.readAsDataURL(compressedFile);
    reader.onloadend = function () {
      const base64data = reader.result;

      SetِData({
        ...getData,
        ["logo"]: base64data,
      } as never);
      console.log(getData);

      console.log(base64data);
    };
  };

  return (
    <>
      <div className="mt-5 mb-5 container">
        <hr />
        <div className="card p-2">
          <b className="py-2">اطلاعات فروشگاه</b>
          <div className="col-lg-12  col-xs-12 d-md-inline-flex  d-lg-inline-flex d-sm-block d-xs-inline-block">
            <div className="col-lg-6 mb-2 col-xs-12  d-md-inline-flex d-lg-inline-flex d-sm-block d-xs-inline-block">
              <InputText
                name="name"
                type="text"
                style={{ width: "100%", marginLeft: "5px" }}
                className="block mb-2"
                placeholder="نام فروشگاه"
                onChange={SetDataInfo}
              />
            </div>
            <div className="p-2 col-lg-6 mb-2 col-xs-12  d-md-inline-flex d-lg-inline-flex d-sm-block d-xs-inline-block">
              نام فروشگاه شما در مکالمات و آگهی های شما نمایش داده خواهد شد
            </div>
          </div>
          <div className="col-lg-12  col-xs-12 d-md-inline-flex  d-lg-inline-flex d-sm-block d-xs-inline-block">
            <div className="col-lg-6 mb-2 col-xs-12  d-md-inline-flex d-lg-inline-flex d-sm-block d-xs-inline-block">
              <InputText
                name="regNo"
                type="text"
                style={{ width: "100%", marginLeft: "5px" }}
                className="block mb-2"
                placeholder="شماره ثبت"
                onChange={SetDataInfo}
              />
            </div>
            <div className="p-2  col-lg-6 mb-2 col-xs-12  d-md-inline-flex d-lg-inline-flex d-sm-block d-xs-inline-block">
              شماره ثبت برای تایید اطلاعات فروشگاه شما مورد استفاده قرار خواهد
              گرفت
            </div>
          </div>

          <div>
            <InputTextarea
              name="description"
              style={{ width: "100%" }}
              placeholder={"توضیحات"}
              rows={7}
              onChange={SetDataInfo}
            />
          </div>
          {/* <div className="mb-2">
            <FileUpload
              ref={fileUploadRef}
              name="img"
              // url="https://primefaces.org/primereact/showcase/upload.php"
              multiple
              accept="image/*"
              maxFileSize={20000000}
              invalidFileSizeMessageSummary=" "
              invalidFileSizeMessageDetail="حداکثر حجم آپلود عکس 1 مگابایت می باشد"
              onUpload={onTemplateUpload}
              onSelect={customBase64Uploader}
              onError={onTemplateClear}
              onClear={onTemplateClear}
              headerTemplate={headerTemplate}
              itemTemplate={itemTemplate}
              emptyTemplate={emptyTemplate}
              chooseOptions={chooseOptions}
              uploadOptions={uploadOptions}
              cancelOptions={cancelOptions}
            />
          </div> */}
        </div>

        <hr />

        <div className="col-12 mt-2 px-2" style={{ width: "100%" }}>
          <Button
            label="ثبت"
            style={{ width: "100%" }}
            onClick={submit}
            className="mt-3 p-button-success"
          />
        </div>
        <hr />
      </div>
    </>
  );
};
export default NewNotice;
function getId(p: any) {
  console.log("enter");
  return (Math.random() * 10).toString();
}
